module.exports = __webpack_public_path__ + "img/sucesso.16af98a8.png";